import { armorAPI } from '~/services/api';
import { JSONBusinessRule, ReorderRulePayload } from '~/types/BusinessRule';

function getBusinessRules() {
  return armorAPI.request<JSONBusinessRule[]>({
    url: `setting/rules/`,
    method: 'GET',
  });
}

function deleteRule(ruleId: string) {
  return armorAPI.request({
    method: 'DELETE',
    url: `setting/rules/${ruleId}/`,
  });
}

function updateRule(payload: unknown) {
  return armorAPI.request<JSONBusinessRule>({
    method: 'PUT',
    url: `setting/rules/`,
    data: payload,
  });
}

function createRule(payload: unknown) {
  return armorAPI.request({
    method: 'POST',
    url: `setting/rules/`,
    data: payload,
  });
}

function reorderRules(payload: { rules: ReorderRulePayload[] }) {
  return armorAPI.request({
    method: 'PUT',
    url: 'setting/rules/reorder/',
    data: payload,
  });
}

function reprocessRules() {
  return armorAPI.request({
    method: 'POST',
    url: 'setting/rules/reprocess/',
  });
}

function getRuleReprocessStatus() {
  return armorAPI.request({
    method: 'GET',
    url: 'setting/rules/reprocess/',
  });
}

export {
  getBusinessRules,
  deleteRule,
  createRule,
  reorderRules,
  updateRule,
  reprocessRules,
  getRuleReprocessStatus,
};
